<template>
  <CCard>
    <CCardHeader>
      <slot name="header">
        <CIcon name="cil-layers"/> {{caption}}
      </slot>
    </CCardHeader>
    <CCardBody>
      <CDataTable
        :hover="hover"
        :striped="striped"
        :bordered="bordered"
        :small="small"
        :fixed="fixed"
        :items="items"
        :fields="fields"
        table-filter
        :items-per-page="small ? 10 : 5"
        :dark="dark"
        pagination
      >
        <template #device="{item}"><td><CLink :to="'assets/'+item.device">{{item.device}}</CLink></td></template>
        <template #time="{item}"><td>{{formatDate(item.time)}}</td></template>
        <template #event="{item}"><td>{{item.event == null ? 'N/A' : item.event }}</td></template>
        <template #zones="{item}"><td><CBadge v-if="m.name !== null" v-for="(m, index) in item.zones" :color="m.id == '00000000-0000-0000-0000-000000000000' ? 'warning' : 'info'" class="mr-1">{{m.name}}</CBadge></td></template>
        <template #actions="{item}"><td><CLink onClick="">edit</CLink></td></template>
      </CDataTable>
    </CCardBody>
  </CCard>
</template>

<script>
export default {
  name: 'TableAssets',
  props: {
    items: Array,
    fields: {
      type: Array,
      default () {
        return ['device', {key: 'devicename', label: 'Name'}, {key: 'time', label: 'Last event'}, 'event', 'zones', 'actions']
      }
    },
    caption: {
      type: String,
      default: 'Table'
    },
    hover: Boolean,
    striped: Boolean,
    bordered: Boolean,
    small: Boolean,
    fixed: Boolean,
    dark: Boolean
  },
  methods: {
    formatDate(date) {
      return date == null ? 'N/A' : (new Date(date*1000)).toLocaleString()
    }
  }
}
</script>
